import Pill from "./Pill";

export default Pill;



// WEBPACK FOOTER //
// ./js/components/Pill/index.js